import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgPencilSimple = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m24.862 8.025-4.887-4.888a1.75 1.75 0 0 0-2.475 0L4.013 16.625a1.734 1.734 0 0 0-.513 1.237v4.888a1.75 1.75 0 0 0 1.75 1.75h4.888a1.737 1.737 0 0 0 1.237-.513L24.862 10.5a1.75 1.75 0 0 0 0-2.475ZM10.138 22.75H5.25v-4.888l9.625-9.625 4.888 4.888-9.625 9.625ZM21 11.887 16.112 7l2.625-2.625 4.888 4.887L21 11.887Z" />
  </svg>
);
export default SvgPencilSimple;
